import React, { FC, useRef, useState } from 'react'
import dayjs from 'dayjs'
import { toast } from 'react-toastify'
import { useStoreon } from 'storeon/react'
import { GxButton, GxDropdown, GxMenu } from '@garpix/garpix-web-components-react'
import { api } from '@/api'
import { Events, State } from '@/interfaces'
import { objectKeys } from '@/utils'

import styles from './styles/styles.module.scss'
import { ORDERS } from '../../../../const'
import { IGetAutogenerationTariffsRes } from '../../../../api/domains/TariffApi/interfaces/response'

interface IDropdownListTariff {
  data?: Record<string, any>
  time: string | undefined
  date: string | undefined
}

const DropdownListTemplate: FC<IDropdownListTariff> = ({ data, time, date }) => {
  const { typeOrder } = useStoreon<State, Events>('ordersInfo', 'typeOrder')
  const [template, setTemplate] = useState<IGetAutogenerationTariffsRes['results']>([])

  const getTemplates = async () => {
    try {
      const response = await api.tariff.getAutogenerationTariffs(1)
      setTemplate(response.results)
    } catch (e) {
      console.log(e)
    }
  }

  const dropdownRef = useRef(null)

  const { dispatch } = useStoreon<State, Events>()

  const handleClickRefresh = () => {
    dispatch('orders/get')
  }

  const handleClickTariff = async (id: number) => {
    const isoFormattedStr = `${date} ${time}`.replace(/\./g, '-')
    const startDate = new Date(isoFormattedStr)

    const endDate = new Date(isoFormattedStr)

    endDate.setMinutes(59)
    endDate.setSeconds(59)

    const startHours = startDate.getHours().toString().padStart(2, '0')
    try {
      await api.tariff.createAutogenerationTariff({
        date: date?.replaceAll(/\./g, '-') || '',
        time: time || '',
        startTime: `${startHours}:00:00`,
        endTime: `${startHours}:59:59`,
        template: id,
        startDate: dayjs(startDate).format('YYYY-MM-DD HH:mm'),
        endDate: dayjs(endDate).format('YYYY-MM-DD HH:mm')
      })
      toast.success('Тариф успешно создан!')
      // @ts-ignore
      dropdownRef.current?.hide()
      handleClickRefresh()
    } catch (e) {
      console.error(e)
      toast.error('Ошибка создания тарифа!')
    }
  }

  return typeOrder === ORDERS.WAVE ? (
    <>
      <div className={styles['order__container']}>
        <GxDropdown className={styles['dropdown']} onGx-show={getTemplates} ref={dropdownRef}>
          <GxButton className={styles['dropdown--btn']} slot='trigger'>
            <span className={styles['dropdown--btn_name']}>
              {(objectKeys(data?.sport_tariff || {}).length > 0
                ? Math.trunc(data?.sport_tariff.price)
                : 0
              ).toLocaleString()}
            </span>
          </GxButton>
          <GxMenu className={styles['dropdown--menu']}>
            {template.length > 0 ? (
              template.map((item) => {
                const firstRate = item.tariff_rates?.[0]
                const hasRates = Boolean(firstRate)
                const formattedPrice = hasRates
                  ? Math.trunc(Number(firstRate?.price)).toLocaleString()
                  : 'Нет ставок'

                return (
                  <div
                    className={`${styles['dropdown--menu__item']} ${
                      !hasRates ? styles['dropdown--menu__item_disabled'] : ''
                    }`}
                    key={item.id}
                    style={{ background: item.color_code }}
                    onClick={hasRates ? () => handleClickTariff(item.id) : undefined}
                    role={hasRates ? 'button' : 'presentation'}
                    tabIndex={hasRates ? 0 : -1}
                    aria-disabled={!hasRates}
                  >
                    <p>{item.name}</p>
                    <p
                      className={
                        hasRates
                          ? styles['dropdown--menu__item_price']
                          : styles['dropdown--menu__item_empty']
                      }
                    >
                      {formattedPrice}
                    </p>
                  </div>
                )
              })
            ) : (
              <div className={styles['dropdown--menu__item']}>
                <p>Нет шаблонов</p>
              </div>
            )}
          </GxMenu>
        </GxDropdown>
      </div>
    </>
  ) : (
    <></>
  )
}

export default DropdownListTemplate
